export default {
  "logoImages": [
    {
      "imgUrl": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/bannerOne.jpg",
      "url": ""
    },
    {
      "imgUrl": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/bannerTwo.jpg",
      "url": ""
    }
  ],
  "reservationEEG": {
    "style": "background-color:#44c1ec80",
    "bgImgUrl": 'https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/EEGLogo.png'
  },
  "departmentIntroduce":[
    "<img src='http://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/keshione.png'/><br>",
    "郑州大学第五附属医院是百年老院,神经外科建立于1983年,是集医、教、研为一体的综合性学科,是河南省神经外科首批重点专科、郑州大学第五付属医院重点科室、特色科室,是河南省最早的神经外科学专业博士、硕士学位授予点之一。<br>",
    "神经外科在复旦医院专科学术排行榜上,在河南省名列三甲。共计三个病区,同时建设有河南省癫痫规范化诊疗疗中心,电生理检测中心,伽马刀中心神经病学研究所,合计156张床位。年手术量接近2000例。年收入1亿多。拥有博士生导师1名,硕士生导师5名,主任医师、教授6名,副主任医师、副教授8名,主治医师12名;博士学位6人,硕士学位24人。设有3个病区,科室固定床位156张。近五年来承担国家级、省、市级科技攻关项目、医学教育项目等20余项,并获得省科技进步奖5项,优秀成果奖5项;在各类杂志发表论文100余篇,核心期刊80余篇,被SCI收录30余篇。<br/>",
    " 拥有一批老中青相结合、医教研实力突出的优秀人才队伍。目前在编神经外科医师三十余名,其中博士生导师1名,硕士生导师5名,教授及主任医师正高级职称7名。省内最早开展顽固性癫痫的外科治疗(获省科技进步奖),在河南省内居于第一位;省内最早开展的颅内外血管搭桥治疗脑缺血性疾病及烟雾病(获省卫生厅新技术新业务引进奖),在省内该领域处于领先地位河南省唯一开展健侧颈7神经异位移植术治疗偏瘫;河南省唯一开展糖尿病足(DPN)神经减压术( dellon术式);河南省唯一开展治疗儿童抽动秽语综合征交感神经网切除术;河南省唯一开展植物人促醒的脊髓此技术(SCS)。<br>",
    "脑血管疑难疾病专项入选国家重点学科能力提升工程,获得国家发改委1.5亿元专项资金和省级发改委配套资金支持，正在申报省级神经病学医疗中心。"
  ],
  "departmentEnvironment": {
    "oneImg": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/keshione.png",
    "twoImg": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/keshitwo.png",
    "threeImg": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/keshithree.png",
    "fourImg": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/keshifour.png"
  },
  "expert": [
    {
      "header": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/wangxinjun.png",
      "name": "王新军",
      "rank": "学科带头人 郑州大学五附院党委书记",
      "lever": "主任医师 教授 医学博士 博士生导师",
      "info": "中华医学会神经外科全国委员、全国颅脑外伤学组委员、河南省神经外科副主任委员、神经创伤学组组长；中国抗癫痫协会理事，河南省抗癫痫专科分会副主委,河南省癫痫规范化治疗中心主任；中国医院协会康复管理委员会常委、河南省主任委员；中国医师协会神经修复学会委员、河南省常委。担任《中华神经外科杂志（英文版）》、《中华实验外科杂志》、《中华临床医师杂志》、《中华脑科疾病与康复杂志》等10种杂志编委。铁道部中青年科技拔尖人才、河南省中青年创新人才、郑州市科技领军人才、河南省优秀医师。从事神经外科临床工作24年，完成各种颅脑脊髓手术六千多例， 开展新业务、新技术25项，承担省、部级科研项目15项，获奖10项。发表论文108篇，专著5部。",
      "time": "周二上午"
    },
    {
      "header": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/shanqiao.jpg",
      "name": "单峤",
      "rank": "",
      "lever": "科主任 主任医师 教授 硕士生导师",
      "info": "中国医药教育学会全国委员;中国医促会全国委员;河南省医学会癫痫专科分会副主委;河南省癫痫规范化治疗中心副主任;河南省神经修复学会功能学组副组长;从事神经外科工作20余年,具有丰富的临床经验。擅长颅内及椎管肿瘤、癫痫的手术治疗,烟雾病及脑缺血疾病的外科治疗,脑血管疾病、脑积水、重型颅脑外伤的外科治疗。开展新业务技术13项,承担国家级、省、市级科技攻关项目、医学教育项目等10余项,并获得省科技进步奖,优秀成果奖;在各类杂志发表论文60余篇,核心期刊50余篇,被SCI收录10余篇。",
      "time": "周二上午"
    },
    {
      "header": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/wuyanzhi.png",
      "name": "吴艳芝",
      "rank": "",
      "lever": "副主任医师 博士",
      "info": "河南省抗癫痫学会委员，河南省医学会神经病学分会青年委员，河南省临床神经电生理分会青年委员，郑州市抗癫痫协会委员，河南省残疾人康复协会精神障碍康复专业委员会青年委员，获取有国家脑损伤脑电图和诱发电位评估合格证书，主要专注于癫痫的诊断、鉴别诊断，癫痫的分型及药物治疗，脑电图的判读，癫痫的术前评估和定位。",
      "time": "周二、周四、周六上午"
    }
  ],
  "checkInfo": {
    "imgOne": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/teseone.png",
    "titleOne": "神经电生理监测",
    "contentOne": "神经电生理监测技术作为显微神经外科手术的辅助措施，对手术涉及的大脑皮层、颅神经及脊髓神经功能起到了极大的保护作用，提高了手术的精细性、准确性和可预见性，保证了手术效果、缩短手术时间，使得我们的手术操作真正达到了微创的效果。",
    "titleTwo": "德国蔡司(ZEISS)手术显微镜",
    "contenttwo": "我科装备的新一代全进口德国蔡司(ZEISS)手术显微镜是目前世界上前沿的手术显微镜，拥有高质量的图像和极优异的分辨率和色保真度，神经和血管纤毫毕现，使复杂的操作变得灵活而简单，极大提高了手术的安全性。具备血管和病变组织的术中荧光造影功能，术中荧光造影可以提供外科医生在正常白光下看不到的影像信息，这些影像信息可以提高术中判断的准确性从而提高手术质量，不仅可以帮助神经外科医生观察到血管中血流的变化，进一步分析血流动态，实现了血管荧光造影技术从定性到量化的飞跃，还可以更准确地定位大脑、脊髓高级别胶质瘤等脑肿瘤的边界，使手术更为安全流畅。全面提升了我科在显微神经外科手术的综合实力。",
    "imgTwo": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/tesetwo.jpg",
    "imgThree": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/tesethree.png",
    "threeTip": "神经电生理导航下外科治疗顽固性癫痫",
    "imgFour": "http://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/tesefour.png",
    "fourTip": "昏迷评估及促醒治疗"
  },
  "visit": [
    {
      "title": "星期一",
      "up": "",
      "down": ""
    },
    {
      "title": "星期二",
      "up": "王新军 单峤 吴艳芝",
      "down": ""
    },
    {
      "title": "星期三",
      "up": "",
      "down": ""
    },
    {
      "title": "星期四",
      "up": "吴艳芝",
      "down": ""
    },
    {
      "title": "星期五",
      "up": "",
      "down": ""
    },
    {
      "title": "星期六",
      "up": "吴艳芝",
      "down": ""
    },
    {
      "title": "星期日",
      "up": "",
      "down": ""
    }
  ],
  "appointment": {
    "place": "门诊二楼外科分诊服务台",
    "time": "上午：8：00--12：00 下午：15：00-18：00（夏季）14：30--17：30（冬季）",
    "phone": "拨打0371-66902016、118114、4001191160、4006677400 → 提供患者本人基本资料并选择时间、专科、专家 → 医院确认预约 → 就诊当日预约挂号服务中心领取挂号凭证 → 按时就诊。（如因特殊情况须改期，请提前致电66902016取消预约，此方法对于远离医院者较方便）",
    "wangshang": "1.发送“预约挂号”邮件至预约邮箱 （zdwfy@zzu.edu.cn ）→ 邮件包括预约时间、专科、专家 → 点击发送 → 医院确认预约→就诊当日预约挂号服务中心领取挂号凭证 → 按时就诊。2.登录河南省预约挂号服务平台、就医160、医护网、名医网等网站注册会员后登录，按流程选择科室、医生进行预约 → 就诊当日预约挂号服务中心领取挂号凭证 → 按时就诊。"
  },
  "service": {
    "imgOne": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/chuzhenxinxi.png",
    "imgTwo": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/yuyueguahao.png",
    "address": "郑州市京广路快速路中段康复前街3号（郑州火车站西广场对面）。",
    "bus": "乘坐201、217路至康复前街京广路站下车。乘坐57、201、213路到火车站西广场站下车。",
    "metro": "乘坐地铁1号线至郑州火车站从C口出站。",
    "place": "门诊楼二楼外科7诊室",
    "time": "每周二上午、周四上午、周六上午",
    "phone": "66916511，66902371",
    "wxNum": "18538111004",
    "map": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/dizhi.png"
  },
  "newsList": [
    {
      "title": "癫痫病患者如何进行自我管理",
      "desc": "癫痫病患者如何进行自我管理",
      "thumbnail": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/newsOne.jpg",
      "linkUrl": "https://mp.weixin.qq.com/s/FU54_sVyJ2RP2ZyUkGVMSQ"
    },
    {
      "title": "癫痫发作病人该如何正确护理",
      "desc": "癫痫发作病人该如何正确护理",
      "thumbnail": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/newsTwo.jpg",
      "linkUrl": "https://mp.weixin.qq.com/s/izkfNE5aB1Dlu7zqq-6EaA"
    },
    {
      "title": "癫痫患者能不能通过手术治愈？",
      "desc": "癫痫患者能不能通过手术治愈？",
      "thumbnail": "https://webimagetest.tongxinyiliao.com/patientPlateForm/zhengda/newsThree.jpg",
      "linkUrl": "https://mp.weixin.qq.com/s/nFousEcOAT4We2R8PFARww"
    }
  ]
}